import { observer } from 'mobx-react-lite';
import { usePluginStore } from '../../../store/RootStoreContext';
import TranslateApp from './TranslateApp';

function TranslateAppContainer({ eventListenerKey, commentText }: { eventListenerKey?: string; commentText: string }) {
    const { translatePlugin, getTranslateLanguageOptions } = usePluginStore();

    const languageOptions = getTranslateLanguageOptions();
    if (!translatePlugin || !languageOptions?.length) {
        return null;
    }

    return (
        <TranslateApp languageOptions={languageOptions} eventListenerKey={eventListenerKey} commentText={commentText} />
    );
}

export default observer(TranslateAppContainer);
